import type { MobileNavigationItem } from './types';

interface MenuLinkProps {
  item: MobileNavigationItem;
  label: string;
}

export default function MenuLink({ item, label }: MenuLinkProps) {
  return (
    <a
      className="bio-mobile-menu__row"
      href={item.url ?? undefined}
      target={item.newTab ? '_blank' : undefined}
      rel={item.newTab ? 'noopener noreferrer' : undefined}
    >
      {label}
    </a>
  );
}
